import { AstraCallout } from '~/astra'
import { dispatchSuccessToast } from '~/store/slices/toasterSlice'

import { dispatchFirstError } from '../../Form/formErrors'
import { FormPageWrapper } from '../../Form/FormWrapper'
import { useResourceNavigation } from '../../useResourceNavigation'
import { useDipsSurgeons } from '../useDipsSurgeons'
import { PractitionerFormParsedValues } from './formState'
import { PractitionerForm } from './PractitionerForm'
import { saveNewPractitioner } from './savePractitioner'

export const NewPractitioner = () => {
    const { dipsResourceId, navigateToList } = useResourceNavigation()
    const dipsResource = useDipsSurgeons().find(r => r.id === dipsResourceId)

    const handleSubmit = async (values: PractitionerFormParsedValues) => {
        if (!dipsResourceId) return
        const results = await saveNewPractitioner(values, dipsResourceId)
        // promise rejections is handled by PractitionerForm
        const error = dispatchFirstError(results)
        if (error) return

        dispatchSuccessToast('Kirurgprofilen er opprettet')
        await navigateToList()
    }

    return (
        <FormPageWrapper backCrumb={{ title: 'Kirurger', onClick: () => void navigateToList() }}>
            {dipsResource?.shortName ? (
                <PractitionerForm
                    isNew
                    title="Ny kirurg til Hero"
                    initialValues={{
                        shortName: dipsResource.shortName,
                        fullName: dipsResource.name ?? dipsResource.shortName,
                        servicePeriods: [{}],
                    }}
                    onSubmit={handleSubmit}
                />
            ) : (
                <AstraCallout text="Fant ikke spesifisert kirurg." color="critical" action={{ label: 'Tilbake til liste', onClick: navigateToList }} />
            )}
        </FormPageWrapper>
    )
}
